import { isUndefined, noop } from 'lodash/fp';
import React, { useMemo } from 'react';

import { getSmileyIcon } from '../../admin/risk-tolerance/utils';
import { Icon } from '../icon/Icon';
import styles from './SharedAnalytics.module.scss';
import { SmileyIndicator } from '../../admin/risk-tolerance/store';

const { green, amber, grey, lightGrey, red, fixedPrimary } = styles;

interface SingleIndicatorProps {
    indicator: SmileyIndicator;
    fontSize?: number;
    onClick?: () => void;
    color?: string;
    fill?: string;
    canClick?: boolean;
}

export const SingleIndicator: React.FC<SingleIndicatorProps> = ({ indicator, fontSize = 36, onClick = noop, color, fill, canClick = false }) => {
    const style = useMemo(() => {
        if (!isUndefined(color) && !isUndefined(fill)) {
            return { fill, color, fontSize };
        }
        if (indicator === SmileyIndicator.POSITIVE) {
            return { fill: green, color: fixedPrimary, fontSize };
        }
        if (indicator === SmileyIndicator.NEGATIVE) {
            return { fill: red, color: fixedPrimary, fontSize };
        }
        if (indicator === SmileyIndicator.NEUTRAL) {
            return { fill: amber, color: fixedPrimary, fontSize };
        }
        return { fill: lightGrey, color: grey, fontSize };
    }, [indicator, fontSize, color, fill]);

    const icon = getSmileyIcon(indicator);

    if (canClick) {
        return (
            <button className={styles.answerIndicatorButton} onClick={onClick}>
                <Icon icon={icon} {...style} />
            </button>
        );
    }

    return (
        <div className={styles.answerIndicator}>
            <Icon icon={icon} {...style} />
        </div>
    );
};
